import styled from '@emotion/styled';
import { fontSize, mediaMax, spacing } from 'presentations/views/styles';
import Link from 'presentations/views/components/atoms/Link';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  black,
  white,
  primary,
  gray05,
} from 'presentations/views/styles/color';

type Props = {
  questions: any;
};

export default function Component(props: Props) {
  return (
    <HelpList>
      {props.questions.map((question: any, index: number) => (
        <HelpLink key={index} href={question.path} target="_blank">
          <HelpArrowIcon name="chevron-right" color="primary" />
          <HelpTitle>{question.title}</HelpTitle>
        </HelpLink>
      ))}
    </HelpList>
  );
}

const HelpList = styled.ul`
  margin-right: ${spacing(24)};
  ${mediaMax.tablet} {
    margin-right: 0;
  }
  background-color: ${white};
  border-radius: 12px;
  padding: ${spacing(16)};
`;
const HelpLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: ${spacing(16)} 0;
  &:hover {
    color: ${primary};
  }
  border-bottom: 1px solid ${gray05};
  :last-of-type {
    border-bottom: 0px solid ${gray05};
  }
`;
const HelpArrowIcon = styled(Icon)`
  width: 20px !important;
  height: 20px !important;
  min-width: ${spacing(32)};
`;
const HelpTitle = styled.span`
  color: ${black};
  font-size: ${fontSize(14)};
`;
